import React from "react";
import {
  BoldActiveIcon,
  BoldIcon,
  CodeActiveIcon,
  CodeIcon,
  ItalicActiveIcon,
  ItalicIcon,
  StrikeThroughActiveIcon,
  StrikeThroughIcon,
  SubScriptActiveIcon,
  SubScriptIcon,
  SuperScriptActiveIcon,
  SuperScriptIcon,
  UnderlineActiveIcon,
  UnderlineIcon,
} from "../../assets/ui-icons";
import ResetState from "./resetstate";
import { Tooltip } from "../input";

const OptionsInput = ({
  value,
  onChange,
  label,
  resetValue = "",
  isResetVisible = true,
  options = [
    {
      value: "bold",
      icon: <BoldIcon />,
      active: <BoldActiveIcon />,
    },
    {
      value: "italic",
      icon: <ItalicIcon />,
      active: <ItalicActiveIcon />,
    },
    {
      value: "underline",
      icon: <UnderlineIcon />,
      active: <UnderlineActiveIcon />,
    },
    {
      value: "strike",
      icon: <StrikeThroughIcon />,
      active: <StrikeThroughActiveIcon />,
    },
    {
      value: "superscript",
      icon: <SuperScriptIcon />,
      active: <SuperScriptActiveIcon />,
    },
    {
      value: "subscript",
      icon: <SubScriptIcon />,
      active: <SubScriptActiveIcon />,
    },
    {
      value: "code",
      icon: <CodeIcon />,
      active: <CodeActiveIcon />,
    },
  ],
}) => {
  if (value === undefined || value === null) {
    value = "";
  }

  const handleStyle = (SelectedValue) => {
    onChange(SelectedValue);
  };

  return (
    <div className="text-grigora-base">
      <div className="text-ui-text-heading mb-2 flex flex-row justify-between items-center">
        {label}
        {isResetVisible && (
          <ResetState
            active={value != resetValue}
            onClick={(e) => {
              onChange(resetValue);
            }}
          />
        )}
      </div>
      <div className="editor-input-box flex justify-between bg-ui-light-white rounded-full px-[14px] py-[3px]">
        {options.map((item) => {
          return (
            <Tooltip
              key={`formatting-${item.value}`}
              text={item.label}
              placement="top"
            >
              <div
                className={`editor-icon-btn ${
                  value === item.value
                    ? "!bg-ui-dark-blue"
                    : "bg-ui-light-white"
                }`}
                onClick={() => {
                  handleStyle(item.value);
                  if (value === item.value) {
                    onChange(undefined);
                  }
                }}
              >
                {value === item.value ? item.active : item.icon}
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default OptionsInput;
